
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import { getData, getImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Cocktails from './cocktails';
import EventsScreen from './events';
import ListProducts from './ListProducts';
import ColdDrinks from './colddrinks';
import Alcoholic from './alcoholic';
import BottleScreen from './bottle';
import Liquours from './liquours';
import Digestivos from './digestivos';
import HouseDrinks from './housedrinks';
import {useTranslation} from 'react-i18next';

function Index({setShowHappy}) { 

    const { change, getInitData } = useRefresh();
    
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;


    const [menus, setMenus] = useState([]);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [housedrinks, sethousedrinks] = useState(false);
    const [swettstuff, setswettstuff] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showColdDrinks, setShowColdDrinks] = useState(false);
    const [showAlcoholic, setShowAlcoholic] = useState(false);
    const [showBottle, setShowBottle] = useState(false);
    const [cocktail, setcoctail] = useState(false);
    const [liquuors, setliquors] = useState(false);
    const [beers, setbeers] = useState(false);
    const [digestivos, setdigestivos] = useState(false);
    const [beer, setbeer] = useState(false);
    const [showLiquors, setshowLiquors] = useState(false);
    const [showDigestivos, setshowDigestivos] = useState(false);
    const [showHouseDrinks, setshowHouseDrinks] = useState(false);
    const [vegan, setvegan] = useState(false);
     const [merch, setmerch] = useState(false);
    const [vegansweet, setvegansweet] = useState(false);
    const [salads, setsalads] = useState(false);
    const [icecream, seticecream] = useState(false);
    const [croasant, setcroasant] = useState(false);
    const [bagel, setbagel] = useState(false);
    const [muffin, setmuffin] = useState(false);
    const [healtty, sethealtty] = useState(false);


     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);

     useEffect(() => {
            menus.map((item) => {
            if (item.id === 992) {
                sethousedrinks(item);
            }
                if (item.id === 993) {
                setsalads(item);
            }
                
            if (item.id === 991) {
                setcoctail(item);
            }
                
            if (item.id === 996) {
                setswettstuff(item);
            }
                
            if (item.id === 987) {
                setliquors(item);
            }
            if (item.id === 991) {
                setbeers(item);
            }
                
                if (item.id === 994) {
                setdigestivos(item);
                }

                if (item.id === 1011) {
                    setbeer(item);
                }

                if (item.id === 995) {
                    setvegan(item);
                }
                 if (item.id === 1031) {
                    setvegansweet(item);
                 }
                
                
            if (item.id === 1032) {
                setmerch(item)
            }
                if (item.id === 1033) {
                seticecream(item)
                }
            if (item.id === 1035) {
                setcroasant(item)
            }
                
            if (item.id === 1036) {
                setbagel(item)
            }
            if (item.id === 1034) {
                setmuffin(item)
            }
                if (item.id === 1037) {
                sethealtty(item)
            }
                
                
        });
    }, [menus]);



    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={setshowCategories} showCocktails={setShowCocktails} showEvents={setShowEvents} showBack={true} setShowSpecials={() => {
                setShowListProduct(true)
                setdishs(merch  )
            }} setShowListProduct={setShowHappy} setShowColdDrinks={setShowColdDrinks}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{ width: '100%', marginBottom: 2, position: 'relative' }}>
                       
                        <img
                             onContextMenu={(e) => e.preventDefault()}
                        style={{
                           width: 150,
                            height: 150,
                            justifyContent: 'center',
                            objectFit: 'contain',
                             pointerEvents: 'none',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -75,
                            
                        }}
                        src={require('./assets/logo2.png')}
                        />
                         
                        <div>
                            <p style={{
                                marginTop: -20,
                                fontSize: 23,
                                fontWeight: 'lighter',
                                color: '#fff',
                                textAlign: 'left',
                                marginLeft: 50,
                                
                            }}>FOOD</p>
                        </div>

                       <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                             gap: 10
                        }}>
                              
                            <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(croasant)
                                
                            }}>
                                <img
                                    src={require('./assets/ARTISANALcorissant.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginTop: 10,
                                        marginBottom: 5,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>

                            <div onClick={() => {
                             setShowListProduct(true)
                               setdishs(bagel)
                                
                            }}>
                                <img
                                    src={require('./assets/BAGEL.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginTop: 10,
                                        marginBottom: 5,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                             gap: 10
                        }}>
                              
                            <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(housedrinks)
                                
                            }}>
                                <img
                                    src={require('./assets/SANDWICHES.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginTop: 1,
                                        marginBottom: 5,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>

                            <div onClick={() => {
                                
                                setShowListProduct(true)
                               setdishs(muffin)
                                
                            }}>
                                <img
                                    src={require('./assets/MUFFIN.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginTop: 1,
                                        marginBottom: 5,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>
                        </div>
                        
                        
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                             gap: 10
                        }}>
                              
                            <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(salads)
                                
                            }}>
                                <img
                                    src={require('./assets/SALADS.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>

                            <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(digestivos)
                                
                            }}>
                                <img
                                    src={require('./assets/SOUPS.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        
                                       
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>
                        </div>
                        

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                             gap: 10
                        }}>

                             <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(healtty)
                                
                            }}>
                                <img
                                    src={require('./assets/HEALTHYFOOD.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginTop: 5,
                                       
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>
                              
                            <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(vegan)
                                
                            }}>
                                <img
                                    src={require('./assets/VEGAN.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginTop: 5,
                                       
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>

                           
                        </div>
                       

                        
                        <div>
                            <p style={{
                                fontSize: 23,
                                fontWeight: 'lighter',
                                color: '#fff',
                                textAlign: 'left',
                                marginLeft: 50,
                                marginTop: 20,
                                
                            }}>DESSERTS</p>
                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                             gap: 10
                        }}>

                             <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(swettstuff)
                                
                            }}>
                                <img
                                    src={require('./assets/SWEET-STUFF.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        
                                        marginBottom: 10,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>

                              <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(vegansweet)
                                
                            }}>
                                <img
                                    src={require('./assets/VEGHANSWEETSTUFF.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: 295,
                                        height: 100,
                                        marginBottom: 10,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>

                        </div>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                             gap: 10
                        }}>

                             <div onClick={() => {
                                
                                setShowListProduct(true)
                                setdishs(icecream)
                                
                            }}>
                                <img
                                    src={require('./assets/KEDAKETOICECREAM.png')}
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{
                                        width: '87%',
                                        height: 100,
                                        
                                        marginBottom: 10,
                                        objectFit: 'contain',
                                        borderRadius: 25,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>


                        </div>
                        


                        

                      
                        
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showColdDrinks && <ColdDrinks setShowHappy={setShowColdDrinks} />}
                {showAlcoholic && <Alcoholic setShowHappy={setShowAlcoholic} />}
                {showBottle && <BottleScreen setShowHappy={setShowBottle} />}
                {showLiquors && <Liquours setShowHappy={setshowLiquors} />}  
                {showDigestivos && <Digestivos setShowHappy={setshowDigestivos} />}  
                {showHouseDrinks && <HouseDrinks setShowHappy={setshowHouseDrinks} />}  
                 {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

            </LayoutContent>
        </div>
    );
}
export default Index;